import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CanActivateViaOAuthGuard } from '../oAuth.canActivateGuard';

import { MatanotReportsComponent } from '../reports/matanot-reports/matanot-reports.component';
import { MatanotComponent } from './matanot.component';
import { MatanotHomeComponent } from "./home/home.component";
import { EndRishumMatanaComponent } from "./end-rishum-matana/end-rishum-matana.component";
import { EndTkufatRishumComponent } from "./end-tkufat-rishum/end-tkufat-rishum.component";
import { HomeChalukatComponent } from "./chaluka/home/chaluka-home.component";
import { ChalukatMatanotComponent } from "./chaluka/chalukat-matanot.component";
import { UpdateChalukatComponent } from "./chaluka/update/chaluka-update.component";

@NgModule({
    imports: [RouterModule.forChild([
        {
            path: 'matanot', component: MatanotHomeComponent, canActivate: [CanActivateViaOAuthGuard], children: [
                { path: 'endrishum', component: EndRishumMatanaComponent },
                { path: 'reports', component: MatanotReportsComponent },
                { path: 'rishum-expired', component: EndTkufatRishumComponent },
                { path: '', redirectTo: 'rishum', pathMatch: 'full' },
                { path: 'rishum', component: MatanotComponent }

            ]
        }, {
            path: 'chalukat-matanot', component: HomeChalukatComponent, canActivate: [CanActivateViaOAuthGuard], children: [
                { path: 'update', component: UpdateChalukatComponent },
                { path: '', redirectTo: 'search', pathMatch: 'full' },
                { path: 'search', component: ChalukatMatanotComponent }
            ]
        }
    ])],
    exports: [RouterModule]
})
export class MatanotRouting { }